"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Panorama360OutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M9.91 17.3A1.91 1.91 0 118 15.4a1.92 1.92 0 011.91 1.9z"/><path d="M29.81 8.51A4.36 4.36 0 0028 6.73a14.95 14.95 0 00-3.63-1.43l-1.14-.28a1.01 1.01 0 00-1.2.77A1.03 1.03 0 0022 6v5.82a30.67 30.67 0 01-3.24.38l-.17.01-.97.05a28.48 28.48 0 01-3.24 0l-.97-.05-.17-.01a30.16 30.16 0 01-3.24-.41V6a1.01 1.01 0 00-1.02-1 1.1 1.1 0 00-.21.02l-1.14.28A14.95 14.95 0 004 6.73a4.36 4.36 0 00-1.81 1.78A2.04 2.04 0 002 9.3v14.6a1 1 0 00.32.74 11.17 11.17 0 003.82 2.18 20.26 20.26 0 002.17.65 31.79 31.79 0 007.69.83 28.5 28.5 0 009.86-1.48c.46-.16 1.27-.53 1.28-.53a10.23 10.23 0 002.1-1.27c.04-.02.44-.38.45-.39a1 1 0 00.31-.73V9.3a2.04 2.04 0 00-.19-.79zM24 7.27c2.45.68 3.8 1.55 3.99 2.03-.19.48-1.54 1.35-3.99 2.03zm-16 0v4.06c-2.45-.68-3.8-1.55-3.99-2.03C4.2 8.82 5.55 7.95 8 7.27zm8 19.03a31.95 31.95 0 01-6.01-.51l6.01-6 2.29 2.3 1 1a1 1 0 101.42-1.43l-.3-.29L23 18.78l4.81 4.81c-1.27.92-4.65 2.71-11.81 2.71zm12-5.34l-4.29-4.3a.99.99 0 00-.7-.29 1.34 1.34 0 00-.19.02.92.92 0 00-.5.25l-.03.02-3.29 3.3-2.29-2.3a1 1 0 00-1.42 0l-7.57 7.58A11.6 11.6 0 014 23.45V11.87a15.14 15.14 0 004 1.53 35.9 35.9 0 005.16.8l1.18.06a43.84 43.84 0 003.32 0l1.18-.06a35.9 35.9 0 005.16-.8 15.14 15.14 0 004-1.53z"/>';
var Panorama360OutlineSVG = function Panorama360OutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.Panorama360OutlineSVG = Panorama360OutlineSVG;
Panorama360OutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(Panorama360OutlineSVG);
exports.default = _default;